import { Checkbox, FormControlLabel, SxProps } from '@mui/material';
import { FormikProps } from 'formik';
import _ from 'react';
import { WsCheckboxProps } from 'stories/inputs/WsCheckbox';

interface WsFormCheckboxProps extends WsCheckboxProps {
  id: string;
  formik: FormikProps<any>;
  onChange?: (...args: any[]) => void;
}

export const WsFormCheckbox = ({ formik, onChange, checked, ...props }: WsFormCheckboxProps) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          sx={{ ...props.sx }}
          inputProps={{ 'aria-label': 'controlled' }}
          checked={Boolean(formik.values[props.id]) || false}
          onChange={onChange ? onChange : formik.handleChange}
          {...props}
        />
      }
      label={props.label}
    />
  );
};
